<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background: transparent ;\nbackground-image: url(\"https:\/\/api.arair.ir\/storage\/asset\/bg.png\");\nbackground-repeat: no-repeat;\nbackground-size: cover;\nheight:100vh;\n"' class=" mt-3 py-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center " >
                <template #default>   <m-video v-bind='{...{"controls":false,"videoSrc":"https:\/\/api.arair.ir\/storage\/asset\/Clean Layered Logo Reveal_fre2e.mp4","autoplay":true,"muted":true,"loop":true,"poster":null},...{}}' :style='" border-radius:35px;"' class="col-8 my-5 border shadow p-0 m-0" ></m-video></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6 text-center" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"nobat\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 35px;"' class="btn btn-primary p-5 border shadow col-12" >
                <template #default>   <m-icon v-bind='{...{"icon":"calendar2-plus"},...{}}' :style='"font-size:70px;"' class="text-secondary " ></m-icon><m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>نوبت دهی پزشکان   </template>
                </m-h1></template>
                </m-div></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6 text-center" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"laser\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 35px;"' class="btn btn-primary p-5 border shadow col-12" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/asset\/1005676.png","alt":""},...{}}' :style='"height:90px"' class="img-fluid" ></m-img><m-h1 v-bind='{...{},...{}}' :style='""' class="mt-3" >
                <template #default>نوبت دهی لیزر مو زائد   </template>
                </m-h1></template>
                </m-div></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center my-5" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"nemonekar\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 35px;"' class="btn btn-primary p-5 border shadow col-12" >
                <template #default>   <m-icon v-bind='{...{"icon":"box2-heart"},...{}}' :style='"font-size:70px;"' class="text-secondary " ></m-icon><m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>نمونه کار ها    </template>
                </m-h1><m-h3 v-bind='{...{},...{}}' :style='""' class="text-gray" >
                <template #default>برای دیدن نمونه کار ها کلیک کنید   </template>
                </m-h3></template>
                </m-div></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"padding-bottom:150px;"' class="col-12 text-center " >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"ContactUS\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 35px;"' class="btn btn-primary p-5 border shadow col-12" >
                <template #default>   <m-icon v-bind='{...{"icon":"person-rolodex"},...{}}' :style='"font-size:70px;"' class="text-secondary " ></m-icon><m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>تماس با ما   </template>
                </m-h1><m-h3 v-bind='{...{},...{}}' :style='""' class="text-gray" >
                <template #default>برای مشاهده اطلاعات ارتباط با ما کلیک کنید   </template>
                </m-h3></template>
                </m-div></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mVideo,mA,mIcon,mH1,mImg,mH3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
